export default __webpack_public_path__ + "static/char-61-274297da6afd93d78f597360a6cf19ca.webp";